export default class Modal {
    constructor(element) {
        this.modal = element
        this.modalWrapper = this.modal.querySelector('.modal-wrapper')
        this.buttonsClose = this.modal.querySelectorAll('.modal-close')

        // Click outside modal
        this.modal.addEventListener('click', (event) => {
            const isClickInside = this.modalWrapper.contains(event.target);
            if (!isClickInside) {
                this.close()
            }
        })

        // Click close button
        this.buttonsClose.forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault()
                this.close()
            })
        })
    }

    open() {
        this.modal.classList.remove('hidden')
    }

    close() {
        this.modal.classList.add('hidden')
    }

    toggle() {
        this.modal.classList.toggle('hidden')
    }
}